import BaseService from './Base';

class TriggerTemplates extends BaseService {
  static endpoint = 'api/2.0/templates-trigger/';
}

export default TriggerTemplates;